// OAuthログイン画面 /oauthLogin
import React, {Component} from 'react';
import { Link } from 'react-router';
import Header from './header'
import Footer from './footer'
import './css/oauthLogin.css';
import { fbLoginForOauth, emailLoginForOauth } from './firebase';
import ToggleDisplay from 'react-toggle-display';
import Toast from './components/toast';
import Recaptcha from 'react-recaptcha';
import define from './define';

let recaptchaInstance;

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailInvalid: false,
      errorMessage: '',
      isToast: false
    }
  }

  async handleFacebookLogin(e){
    const uid = await fbLoginForOauth();
    // 認可コード発行API実行
    const { clientId, redirectUri } = this.props.location.state;
    const queryParams = `?user_id=${uid}&client_id=${clientId}&redirect_uri=${redirectUri}`;
    const url = `/oauth/authorize${queryParams}`;
    fetch(url)
      .then(res => {
        return res.json()
      })
      .then(data => {
        if ('invalid_user' === data.error) {
          // FBでのユーザー登録がない
          this.setState({isToast: 'isUser' })
          return
        }
        // クライアントアプリのリダイレクトURIへ
        window.location.href = `${data.redirectUri}?code=${data.code}`
        return
      })
      .catch((err) => {
        console.log(err)
        return
      })
  }

  async handleEmailLogin(e) {
    e.preventDefault();
    const email = this.state.email;
    const password = this.state.password;

    if (undefined === email || 0 === email.length) {
      this.setState({ errorMessage: '※メールアドレスを入力してください' });
      this.setState({ emailInvalid: true });
      return;
    } else if (undefined === password || 0 === password.length) {
      this.setState({ errorMessage: '※パスワードを入力してください' });
      this.setState({ emailInvalid: true });
      return;
    }

    try {
      // login
      const uid = await emailLoginForOauth(email, password);
      // 認可コード発行API実行
      const { clientId, redirectUri } = this.props.location.state;
      const queryParams = `?user_id=${uid}&client_id=${clientId}&redirect_uri=${redirectUri}`;
      const url = `/oauth/authorize${queryParams}`;
      fetch(url)
        .then(res => {
          return res.json()
        })
        .then(data => {
          // クライアントアプリのリダイレクトURIへ
          window.location.href = `${data.redirectUri}?code=${data.code}`
          return
        })
        .catch((err) => {
          console.log(err)
          return
        })

    } catch (err) {
      // login error
      if ('auth/wrong-password' === err.code || 'auth/user-not-found' === err.code || 'auth/invalid-email' === err.code) {
        this.setState({ errorMessage: '※メールアドレスまたはパスワードが違います'});
        this.setState({ emailInvalid: true });
      }
      return;
    }
  }

  handleEmailChange(e) {
    this.setState({email: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  verifyCallback = token => {
    const url = `/api/verifyRecaptchaToken?response=${token}`

    fetch(url)
      .then(res => {
        return res.json()
      })
      .then(data => {
        if (!data.error) {
          // make login button clickable
          const el = document.getElementById('recaptcha-button');
          el.classList.remove('disabled');
          el.removeAttribute('disabled');
          return
        }
        console.log(recaptchaInstance)
        // reCAPTCHAのチェックボックスのチェックを外す
        recaptchaInstance.reset()
      })
  }

  returnToast = () => {
    const {
      isToast
    } = this.state

    if(isToast) {
      let message
      if(isToast === 'isUser') {
        message = (<div className="toast-caution"><p>MyRateのアカウントが存在しません。</p><p>ご登録をお願いします。</p></div>)
      }
      return (
        <Toast notifyMessage={message} />
      )
    }
  }
  render() {
    return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-login">
      {this.returnToast()}
        <Header isOauth={true} />
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-login">
                  <h2 className="subtitle-en">MyRate Login</h2>
                  <div className="">
                    <p className="login-statement">MyRateにログインしてください</p>
                    <form className="form-login">
                      <button className="submit" type="button" onClick={(e) => {this.handleFacebookLogin(e)}}><span className="fb-button">Facebookでログインする</span></button>
                    </form>

                    <hr />

                    <form className="form-login" onSubmit={(e) => {this.handleEmailLogin(e)}}>
                    <ToggleDisplay if={this.state.emailInvalid}>
                      <p>{this.state.errorMessage}</p>
                    </ToggleDisplay>
                      <input type="text" name="email" value={this.state.email} onChange={(e) => this.handleEmailChange(e)} placeholder="メールアドレスを入力ください"></input>
                      <input type="password" name="password" value={this.state.password} onChange={(e) => this.handlePasswordChange(e)} placeholder="パスワードを入力ください"></input>

                      <Recaptcha
                        ref={e => recaptchaInstance = e}
                        sitekey={define.RECAPTCHA_CONFIG.siteKey}
                        size="normal"
                        render="explicit"
                        verifyCallback={this.verifyCallback}
                        badge='inline'
                        hl='ja'
                        onloadCallback={() => {}}
                      />

                      <button id="recaptcha-button" className="recaptcha submit disabled" disabled type="submit"><span className="mail-button">メールアドレスでログインする</span></button>
                    </form>

                    <Link to='/newflow1' className="acccount-register-link">MyRateアカウントを作成する</Link>
                  </div>
                </div>
              </div>

            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/oauthLogin.js